<template>
  <section class="crancy-wc crancy-wc__full crancy-bg-cover login-cover">
    <div class="crancy-wc__form">
      <div class="crancy-wc__form--middle">
        <div class="crancy-wc__banner position-relative login-image-holder">
          <div class="image-overlay-text position-absolute">
            <h2>{{ $t("Start selling for Bitcoin now!") }}</h2>
            <h4>
              {{
                $t(`Offer Coinsnap bitcoin-lightning payment now and increase you customer base across the planet!`)
              }}</h4>
          </div>
        </div>
        <div class="crancy-wc__form-inner">
          <div class="text-center mb-4">
            <a href="/">
              <img alt="Coinsnap" src="../assets/img/logo.png"></a>
          </div>
          <div class="crancy-wc__heading">
            <h3 v-if="!showPopup" class="crancy-wc__form-title crancy-wc__form-title__one text-center">
              {{ $t("Create account") }}</h3>
            <h3 v-if="showPopup" class="crancy-wc__form-title crancy-wc__form-title__one text-center">
              {{ $t("Verify your email") }}</h3>
            <p v-if="!showPopup" class="text-center">{{ $t("Create account with your email and password") }}</p>
          </div>
          <transition name="fade">
            <div v-if="hasError" class="alert alert-danger mt-4" role="alert">
              {{ message }}
            </div>
          </transition>
          <transition name="fade">
            <div v-if="showPopup" class="mt-4">
              <div class="alert alert-success mt-2" role="alert">
                {{ $t("We\'ve sent you a verification email.") }}
                {{ $t("Please follow the instructions in the email.") }}
              </div>
              <div class="crancy-wc__button">
                <button @click="$router.push('/login')" class="ntfmax-wc__btn mt-4" type="button">
                  {{ $t("Go back") }}
                </button>
              </div>
            </div>
          </transition>
          <form v-if="!showPopup" class="crancy-wc__form-main">
            <div class="form-group">
              <div class="form-group__input">
                <input class="crancy-wc__form-input" novalidate :class="{ 'errorField': emailError }"
                       v-model="email" type="text" placeholder="Enter Email" id="emailForm" autofocus required>
              </div>
            </div>

            <div class="form-group">
              <div class="form-group__input">
                <input class="crancy-wc__form-input" novalidate
                       v-model="password" @keyup.enter="recaptcha" @input="checkPassword" type="password"
                       placeholder="Enter Password"
                       id="passwordForm" required>
                <span class="crancy-wc__toggle"><input type="checkbox" class="fas fa-eye" id="toggle-icon"
                                                       v-model="showPassword"></span>
              </div>
              <div class="validator">
                <p class="frmValidation" :class="{'frmValidation--passed' : password.length > 7 }">
                  <i class="frmIcon fas" :class="password.length > 7 ? 'fa-check' : 'fa-times'"></i>
                  Longer than 7 characters
                </p>
                <p class="frmValidation" :class="{'frmValidation--passed' : has_uppercase }">
                  <i class="frmIcon fas" :class="has_uppercase ? 'fa-check' : 'fa-times'"></i>
                  Has a capital letter
                </p>
                <p class="frmValidation" :class="{'frmValidation--passed' : has_lowercase }">
                  <i class="frmIcon fas" :class="has_lowercase ? 'fa-check' : 'fa-times'"></i>
                  Has a lowercase letter
                </p>
                <p class="frmValidation" :class="{'frmValidation--passed' : has_number }">
                  <i class="frmIcon fas" :class="has_number ? 'fa-check' : 'fa-times'"></i>
                  Has a number
                </p>
                <p class="frmValidation" :class="{'frmValidation--passed' : has_special }">
                  <i class="frmIcon fas" :class="has_special ? 'fa-check' : 'fa-times'"></i>
                  Has a special character
                </p>
              </div>
            </div>

            <div class="form-group">
              <div class="form-group__input">
                <input class="crancy-wc__form-input" novalidate :class="{ 'errorField': referralError }"
                       v-model="referralCode" @keyup.enter="recaptcha" type="text"
                       placeholder="Enter referral Code"
                       id="referralForm">
              </div>
            </div>
            <div class="form-group visually-hidden">
              <div class="form-group__input">
                <input class="crancy-wc__form-input" novalidate v-model="url" type="text"
                       placeholder="Enter bot code" id="urlForm">
              </div>
            </div>
            <b-tooltip target="passwordForm" placement="right" custom-class="tt">
              {{ $t("Use 8 or more characters with a mix of letters, numbers and symbols") }}
            </b-tooltip>

            <!-- Form Group -->
            <div class="form-group form-mg-top25">
              <div class="crancy-wc__button">
                <button class="ntfmax-wc__btn" :disabled="passwordError" type="button" @click="recaptcha()">
                  {{ $t("Create account") }}
                </button>
              </div>
            </div>
            <p class="crancy-wc__text text-center mt-4">
              {{ $t("By clicking on create account you are accepting") }}
              <a href="#" @click="openNewTab('https://coinsnap.io/en/general-terms-and-conditions/')">
                {{ $t("Terms of Service.") }}
              </a>
            </p>
            <!-- Form Group -->
            <div class="form-group form-mg-top30">
              <div class="crancy-wc__bottom">
                <p class="crancy-wc__text d-flex justify-content-center">
                  {{ $t("You already have account? Log in with") }}&nbsp;
                  <router-link class="nav-link" to="/login">
                    {{ $t("email") }}
                  </router-link>
                </p>
              </div>
            </div>
          </form>
          <!-- End Sign in Form -->
        </div>
      </div>
      <!-- End Welcome Banner -->
      <FooterLogin></FooterLogin>
    </div>
  </section>
</template>

<script>
import {getCookie} from '@/assets/js/sharedFunctions';
import FooterLogin from "@/views/FooterLogin.vue";

export default {
  name: "RegisterView",
  components: {
    FooterLogin
  },
  data() {
    return {
      email: "",
      password: "",
      showPopup: false,
      showPassword: false,
      hasError: false,
      message: "",
      emailError: false,
      passwordError: true,
      referralError: false,
      referralCode: "",
      url: "",
      has_number: false,
      has_lowercase: false,
      has_uppercase: false,
      has_special: false,
    }
  },
  watch: {
    showPassword(newVal) {
      let currentPassword = document.getElementById("passwordForm")
      currentPassword.type = newVal ? "text" : "password"
    },
  },
  mounted() {
    var refCode = this.$route.query.referralCode
    if (!refCode) refCode = this.$route.query.ref

    const refCodeCookie = getCookie("coinsnap-refCode")?.split(" expires")[0]
    if (refCode) {
      this.referralCode = refCode
      let expirationDate = new Date();
      expirationDate.setTime(expirationDate.getTime() + (30 * 24 * 60 * 60 * 1000));
      document.cookie = `coinsnap-refCode=${refCode} expires=${expirationDate.toUTCString()}; path=/`
    } else if (refCodeCookie) {
      this.referralCode = refCodeCookie
    }
  },

  methods: {
    checkPassword() {
      this.has_number = /\d/.test(this.password);
      this.has_lowercase = /[a-z]/.test(this.password);
      this.has_uppercase = /[A-Z]/.test(this.password);
      this.has_special = /[!@#\$%\^\&*\)\(+=._-]/.test(this.password);

      this.passwordError = !this.has_number || !this.has_lowercase || !this.has_uppercase || !this.has_special || this.password < 8;
    },
    openNewTab(url) {
      window.open(url, '_blank');
    },
    async recaptcha() {
      this.emailError = this.email === ""

      this.checkPassword()

      if (this.emailError || this.passwordError) {
        return;
      }

      try {
        // Wait until reCAPTCHA has been loaded
        await this.$recaptchaLoaded();
        // Execute reCAPTCHA with action "login"
        const token = await this.$recaptcha('login');

        if (!token) {
          return;
        }

        // Proceed with login
        await this.register(token);
      } catch (error) {
        console.error('reCAPTCHA error:', error);
      }
    },

    register(token) {
      this.hasError = false
      this.$store.dispatch('postApiCallAction', {
        hook: '/signup',
        body: {
          'referralCode': this.referralCode,
          'email': this.email,
          'password': this.password,
          'url': this.url,
          'captcha': token
        },
        json: true
      }).then(res => {
        if (res?.success) {
          this.showPopup = true;
        } else if (res?.message) {
          this.hasError = true
          this.message = res.message
        }
      });
    },

  },
};
</script>
